import { CancelTokenSource } from 'axios';
import { CovidTestAnalyzerDto, UpsertCovidTestAnalyzerDto } from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/covid-test-analyzer`;

export const getAllCovidTestAnalyzers = (source: CancelTokenSource): Promise<CovidTestAnalyzerDto[]> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const findCovidTestAnalyzerById = (
    id: number, source: CancelTokenSource): Promise<UpsertCovidTestAnalyzerDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getAllCovidTestAnalyzersForLab = (labId: number,
                                               source: CancelTokenSource): Promise<CovidTestAnalyzerDto[]> => {
  return axios
      .get(`${apiUri}/lab/${labId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const addCovidTestAnalyzer = (
    upsertCovidTestAnalyzerDto: Partial<UpsertCovidTestAnalyzerDto>,
    source: CancelTokenSource)
    : Promise<CovidTestAnalyzerDto> => {

  return axios
      .post(apiUri, upsertCovidTestAnalyzerDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editCovidTestAnalyzer = (
    id: number,
    upsertCovidTestAnalyzerDto: Partial<UpsertCovidTestAnalyzerDto>,
    source: CancelTokenSource)
    : Promise<CovidTestAnalyzerDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertCovidTestAnalyzerDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteCovidTestAnalyzer = (
    id: number, source: CancelTokenSource)
    : Promise<number> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
